"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![ExternalDBIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMC43IDE0IiBoZWlnaHQ9IjMwIiB3aWR0aD0iMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5FeHRlcm5hbERCPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTUuMzUsMy4xM2MzLjIxLDAsNS4zNS0uOTQsNS4zNS0xLjU3UzguNTYsMCw1LjM1LDAsMCwuOTQsMCwxLjU2LDIuMTMsMy4xMyw1LjM1LDMuMTNaIi8+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsM3Y5LjQyQzAsMTMuMDYsMi4xMywxNCw1LjM1LDE0czUuMzUtLjk0LDUuMzUtMS41N1YzQTExLjA4LDExLjA4LDAsMCwxLDUuMzUsNC4xMywxMS4wNSwxMS4wNSwwLDAsMSwwLDNabTcuODIsNS4xVjkuNTZINC40OHYxLjMyaDMuOHYxLjQ2SDIuNjV2LTdIOC4xOFY2LjhINC40OFY4LjExWiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.ExternalDBIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 10.7 14", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M5.35 3.13c3.21 0 5.35-.94 5.35-1.57S8.56 0 5.35 0 0 .94 0 1.56s2.13 1.57 5.35 1.57z" }),
        React.createElement("path", { d: "M0 3v9.42C0 13.06 2.13 14 5.35 14s5.35-.94 5.35-1.57V3a11.08 11.08 0 0 1-5.35 1.13A11.05 11.05 0 0 1 0 3zm7.82 5.1v1.46H4.48v1.32h3.8v1.46H2.65v-7h5.53V6.8h-3.7v1.31z" })));
};
//# sourceMappingURL=Icon.ExternalDB.js.map